import { createGlobalStyle } from 'styled-components';

export const theme = {
  colors: {
    magenta: '#84064F',
    navy: '#18587B',
    orange: '#FF5433',
    white: '#FFFFFF',
    black: '#000000',
  },
  fonts: {
    headline: "'Montserrat', sans-serif",
    content: "'Lato', sans-serif",
  },
  screens: {
    tablet: '768px',
  }
};

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.content};
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.black};
  }
`;

